export const ENVIRONMENT_CONSTANTS = {
  REACT_APP_MEMBER_PORTAL_ENDPOINT_URL: "REACT_APP_MEMBER_PORTAL_ENDPOINT_URL",
  REACT_APP_MEMBER_PORTAL_MEMBER_SERVICES_EMAIL:
    "REACT_APP_MEMBER_PORTAL_MEMBER_SERVICES_EMAIL",
  REACT_APP_ORDER_MEMBER_PORTAL_ENDPOINT_URL:
    "REACT_APP_ORDER_MEMBER_PORTAL_ENDPOINT_URL",
  REACT_APP_GOOGLE_PLACES_API_KEY: "REACT_APP_GOOGLE_PLACES_API_KEY",
  REACT_APP_RISK_API_ENDPOINT_URL: "REACT_APP_RISK_API_ENDPOINT_URL"
};
